import { TranslationKey } from './../../../../../../../../types/translation/TranslationKey';
import React, { useContext, useMemo } from 'react';
import {
  ProductTransaction,
  ProductTransactionStatus,
  ProductTransactionType,
} from '../../../../../../../../types/productTransaction';
import { Grid } from '@mui/material';
import { t } from '../../../../../../../../types/translation/Translator';
import { Container } from '../../../../../../../../types/container';
import { CompanyContext } from '../../../../../../../../context/CompanyContext';
import { ProductTransactionContext } from '../../../../../../../../context/ProductTransactionContext';
import { Checkbox } from '../../../../../../../components/Checkbox';

interface ProductTransactionProcessContainerChildrenProps {
  transaction: ProductTransaction;
  setTransaction: React.Dispatch<React.SetStateAction<ProductTransaction>>;

  container?: Container;

  disabled?: boolean;
}

export default function ProductTransactionProcessContainerChildren({
  transaction,
  setTransaction,
  container,
  disabled = false,
}: ProductTransactionProcessContainerChildrenProps) {
  const { currentCompany } = useContext(CompanyContext);
  const { productTransactions } = useContext(ProductTransactionContext);

  const showContainer = useMemo(() => currentCompany.settings.featureToggles.containers.containers, [currentCompany]);

  if (!showContainer) return null;
  if (transaction.type !== ProductTransactionType.inbound) return null;
  if (transaction.status !== ProductTransactionStatus.created) return null;
  if (!transaction.product.toContainerId) return null;

  const hasCreated =
    [...productTransactions.values()].find(
      el => el.parentId === transaction.parentId && el.product.containerId === transaction.product.toContainerId,
    )?.status === ProductTransactionStatus.created;

  if (!hasCreated) return null;

  return (
    <Grid item xs={12}>
      <Checkbox
        value={transaction.product.containerComplete || false}
        onChange={value => setTransaction(transaction => transaction.withContainerComplete(value))}
        label={t(TranslationKey.processChildrenQuestion).singular.upper}
      />
    </Grid>
  );
}
